// PatientQueue.jsx
// Shows all patients currently in WAITING or IN_PROGRESS state.

import PatientCard from "./PatientCard.jsx";

export default function PatientQueue({
  sessions,
  queueError,
  callError,
  onAdmit,
  onForceEnd,
  onRefresh,
}) {
  const waiting    = sessions.filter((s) => s.status === "WAITING");
  const inProgress = sessions.filter((s) => s.status === "IN_PROGRESS");

  return (
    <div className="queue-page">

      {/* Header */}
      <div className="page-header">
        <div>
          <h1 className="page-title">Patient Queue</h1>
          <p className="page-subtitle">
            Patients waiting in their virtual lobby. Select one to start the visit.
          </p>
        </div>
        <button
          className="btn btn-ghost btn-sm"
          onClick={onRefresh}
          aria-label="Refresh patient queue"
        >
          ↻ Refresh
        </button>
      </div>

      {/* Error banners */}
      {queueError && (
        <div className="alert alert-error" role="alert">
          <span aria-hidden="true">⚠️</span> Could not load queue: {queueError}
        </div>
      )}
      {callError && (
        <div className="alert alert-error" role="alert">
          <span aria-hidden="true">📡</span> Could not start call: {callError}
        </div>
      )}

      {/* Stats row */}
      <div className="stats-row">
        <StatCard value={waiting.length}    label="Waiting"     color="teal"  />
        <StatCard value={inProgress.length} label="In Progress" color="green" />
        <StatCard value={sessions.length}   label="Total"       color="navy"  />
      </div>

      {/* Waiting section */}
      {waiting.length > 0 && (
        <section aria-labelledby="waiting-heading">
          <h2 className="queue-section-title" id="waiting-heading">
            <span className="section-dot section-dot--waiting" aria-hidden="true" />
            Waiting ({waiting.length})
          </h2>
          <div className="card-grid">
            {waiting.map((s) => (
              <PatientCard
                key={s.sessionId}
                session={s}
                onAdmit={onAdmit}
                onForceEnd={onForceEnd}
              />
            ))}
          </div>
        </section>
      )}

      {/* In-progress section */}
      {inProgress.length > 0 && (
        <section aria-labelledby="inprogress-heading" style={{ marginTop: 32 }}>
          <h2 className="queue-section-title" id="inprogress-heading">
            <span className="section-dot section-dot--active" aria-hidden="true" />
            In Progress ({inProgress.length})
          </h2>
          <div className="card-grid">
            {inProgress.map((s) => (
              <PatientCard
                key={s.sessionId}
                session={s}
                onAdmit={onAdmit}
                onForceEnd={onForceEnd}
                disabled
              />
            ))}
          </div>
        </section>
      )}

      {/* Empty state */}
      {sessions.length === 0 && !queueError && (
        <div className="empty-state">
          <span className="empty-icon" aria-hidden="true">🪑</span>
          <h3>No patients waiting</h3>
          <p>Send an invite to get a patient into their virtual waiting room.</p>
        </div>
      )}
    </div>
  );
}

function StatCard({ value, label, color }) {
  return (
    <div className={`stat-card stat-card--${color}`}>
      <span className="stat-value">{value}</span>
      <span className="stat-label">{label}</span>
    </div>
  );
}
